// theme.ts
import { createTheme, ThemeOptions } from '@mui/material/styles';

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      // A deep navy blue – adjust to match the Buckeye Reinsurance brand
      main: '#002B5C',
    },
    secondary: {
      // A bright orange accent – adjust as needed
      main: '#FF6F00',
    },
    background: {
      default: '#F5F5F5', // Light background
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
};

const theme = createTheme(themeOptions);

export default theme;